import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=082110e6&scoped=true"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"
import style0 from "./CommentModal.vue?vue&type=style&index=0&id=082110e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082110e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082110e6')) {
      api.createRecord('082110e6', component.options)
    } else {
      api.reload('082110e6', component.options)
    }
    module.hot.accept("./CommentModal.vue?vue&type=template&id=082110e6&scoped=true", function () {
      api.rerender('082110e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/comment-modal/CommentModal.vue"
export default component.exports